module.exports = __webpack_public_path__ + "img/hr-water-green2.15bc9af1.png";